import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Tab, TabNavigationModel } from '@zero/shared/util-models';

@Component({
  selector: 'web-design-system-tab-navigation',
  imports: [TranslocoPipe],
  templateUrl: './tab-navigation.component.html',
  styleUrl: './tab-navigation.component.scss',
})
export class TabNavigationComponent {
  @Input() public model: TabNavigationModel;

  @Output() public tabChange = new EventEmitter<string>();

  public onTabChange(tabId: string): void {
    this.model.tabs.forEach((tab: Tab) => (tab.active = tab.id === tabId));
    this.tabChange.emit(tabId);
  }
}
